module.exports = "/_next/static/images/section-for-ec-55d711f35f25883b1cbb2da958da1295.jpg.webp";